export default "__VITE_ASSET__6b43711c__"